// Configuration for backend URL based on environment
// IMPORTANT: Set VITE_BACKEND_URL in your .env for production (Cloud Run URL)

export function getBackendUrl() {
  // Use VITE_BACKEND_URL if set (works for both dev and production)
  if (import.meta.env.VITE_BACKEND_URL) {
    return import.meta.env.VITE_BACKEND_URL;
  }

  // Default: localhost:8082 for development, Cloud URL for production
  if (process.env.NODE_ENV === 'development') {
    return 'http://localhost:8082';
  }

  return 'https://api.segmently.ai';
}

// Helper function to get current environment for API calls
export function getCurrentEnvironment() {
  return import.meta.env.VITE_NODE_ENV || 'development';
} 